import BlankNotice from '@components/blank/BlankNotice';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';

import useNotices from './hooks/useNotices';
import NoticeItem from './NoticeItem';
import styles from './styles.module.scss';

function NoticeList() {
  const {
    notices, fetchNext, isLoading, isBlank,
  } = useNotices();
  return (
        <Column as='main' fullWidth spacing={18}
                align='center'
                className={styles.container} >
            {isBlank && (
                <BlankNotice/>
            )}
            {notices.map((notice) => (
                <NoticeItem notice={notice}
                            key={notice.id} />
            ))}
            {isLoading && (
                <Loading size='small' />
            )}
            <InfinityScrollTrigger trigger={fetchNext}/>
        </Column>
  );
}

export default NoticeList;
